module.exports = __webpack_public_path__ + "static/media/audio.cdb854bc.svg";